import React, { useContext } from 'react';
import { Flex, Box, Icon, Image } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiHome, FiCompass, FiMail, FiTarget } from 'react-icons/fi';
import { InfluencerDataContext } from '../contexts/InfluencerDataContext';
import { ff } from '../theme';

const tabs = [
  { icon: FiHome, label: 'Home', path: '/collabs' },
  { icon: FiCompass, label: 'Explore', path: '/explore' },
  { icon: FiMail, label: 'Inbox', path: '/inbox' },
  { icon: FiTarget, label: 'Bounties', path: '/bounties' },
  { icon: null, label: 'Profile', path: '/profile' },
];

const TabBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { influencerData } = useContext(InfluencerDataContext);
  const initial = (influencerData?.firstName || influencerData?.instagramHandle || '?').charAt(0).toUpperCase();

  return (
    <Flex
      as="nav"
      aria-label="Main"
      fontFamily="display"
      position="fixed"
      left="50%"
      transform="translateX(-50%)"
      bottom="calc(24px + env(safe-area-inset-bottom))"
      h="60px"
      px="8px"
      gap="2px"
      borderRadius="full"
      bg={ff.ink}
      align="center"
      zIndex={1000}
      boxShadow="0 10px 24px -12px rgba(0,0,0,.5)"
    >
      {tabs.map(tab => {
        const active = location.pathname.startsWith(tab.path);
        const glyph = tab.icon ? (
          <Icon as={tab.icon} boxSize={active ? '20px' : '22px'} strokeWidth={active ? 2.2 : 2} />
        ) : (
          <Flex
            w="26px"
            h="26px"
            borderRadius="full"
            bg="white"
            color={ff.ink}
            align="center"
            justify="center"
            fontSize="12px"
            fontWeight={600}
            overflow="hidden"
            boxShadow={active ? `0 0 0 2px ${ff.ink}` : undefined}
          >
            {influencerData?.profile_pic_url ? (
              <Image src={influencerData.profile_pic_url} alt="" w="100%" h="100%" objectFit="cover" />
            ) : (
              initial
            )}
          </Flex>
        );
        return (
          <Box
            as="button"
            key={tab.path}
            aria-label={tab.label}
            aria-current={active ? 'page' : undefined}
            onClick={() => navigate(tab.path)}
            h="44px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="6px"
            borderRadius="full"
            {...(active
              ? { bg: ff.lime, bgImage: ff.limeGradient, boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.45)', color: ff.ink, pl: '12px', pr: '14px', fontSize: '14px', fontWeight: 600 }
              : { w: '52px', color: ff.muted })}
          >
            {glyph}
            {active && tab.label}
          </Box>
        );
      })}
    </Flex>
  );
};

export default TabBar;
